import AbstractLoginModal, {
  AbstractLoginModalTemplateSpec,
  LoginFlow,
} from '../layout/AbstractLoginModal';
import { AppData, Colors, Lightning } from '@lightningjs/sdk';
import SignInContent from './SignInContent';
import { ConfirmationType } from '../confirmation/EmailConfirmationModal';
import TextLabel from 'components/common/TextLabel';

export interface SignInModalTemplateSpec
  extends AbstractLoginModalTemplateSpec {
  Content: {
    Heading: typeof TextLabel;
    Frame: object;
  } & AbstractLoginModalTemplateSpec['Content'];
}

const CONTENT_HEIGHT = 586;
const EMPTY_HEADING_SPACE = 89;
const CONTENT_OFFSET_Y = 229 + EMPTY_HEADING_SPACE;

export default class SignInModal extends AbstractLoginModal {
  override _showBackButton = false;

  override get loginFlow() {
    return LoginFlow.SIGN_IN;
  }

  private _Frame = this._Content.getByRef('Frame')!;

  static override _template(): Lightning.Component.Template<SignInModalTemplateSpec> {
    const { Content, ...rest } = super._template();
    return {
      Content: {
        ...Content,
        y: CONTENT_OFFSET_Y,
        h: CONTENT_HEIGHT,
        Frame: {
          type: SignInContent,
          h: CONTENT_HEIGHT,
          w: Content!.w,
          rect: true,
          color: Colors('loginBackground').get(),
          signals: {
            $onEmailInputHovered: '$onEmailInputHovered',
            $onButtonHovered: '$onButtonHovered',
            $openKeyboard: '$openKeyboard',
            $usePassword: '$usePassword',
            $signInLink: '$signInLink',
            $resetToEmailInput: '$resetToEmailInput',
          },
        },
      },
      ...rest,
    };
  }

  modalInit(data: { email: string }) {
    this._Frame.email = data.email;
  }

  override _getFocused() {
    return this._Frame;
  }

  private $onEmailInputHovered() {
    this._setState('Content');
  }

  private $onButtonHovered() {
    this._setState('Content');
  }

  private async $signInLink(email: string) {
    const smartLoginService = AppData?.smartLoginService;
    if (!smartLoginService) return;

    const linkSent = await this.onLoading(
      smartLoginService.sendSignInEmail(email),
    );

    if (linkSent) {
      AppData?.modalService.open('EmailConfirmationModal', {
        data: { email, confirmationType: ConfirmationType.SIGN_IN },
      });
    }
  }

  private $usePassword(email: string) {
    AppData?.modalService.open('SignInPasswordModal', {
      data: { email },
    });
  }
}
